import { BASE_URL, BACKEND_URL } from '../utils/consts';
import axios from 'axios';

const surveyInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const backendInstance = axios.create({
  baseURL: BACKEND_URL,
});

export const apiCall = (url, method = 'GET', data) =>
  surveyInstance({
    method: method,
    url: url,
    data: data,
  });

export const assistantApi = {
  getLanguages: ({ id } = {}) =>
    backendInstance.request({
      method: 'GET',
      url: `/assistant/languages/${id}/`,
    }),
};
